import React, { Children, PureComponent } from "react";
import PropTypes from "prop-types";
import StaleLoader from "components/StaleLoader";
import SearchInput from "@zendesk/knowledge-components/lib/SearchInput";
import { Separator } from "@zendeskgarden/react-menus";

import NoResults from "./NoResults";
import SearchFailure from "./SearchFailure";

import styles from "./styles.css";

class SearchMenuItems extends PureComponent {
  static propTypes = {
    loading: PropTypes.bool,
    children: PropTypes.node,
  };

  render() {
    const { children, loading } = this.props;

    if (!loading && Children.count(children) === 0) {
      return <NoResults />;
    }

    return <StaleLoader loading={loading}>{children}</StaleLoader>;
  }
}

class SearchMenuInput extends PureComponent {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
  };

  render() {
    return (
      <React.Fragment>
        <div className={styles.searchInput}>
          <SearchInput onChange={this.props.onChange} />
        </div>
        <Separator />
      </React.Fragment>
    );
  }
}

export default class SearchMenu extends PureComponent {
  static Input = SearchMenuInput;
  static Items = SearchMenuItems;
  static SearchFailure = SearchFailure;

  static propTypes = {
    children: PropTypes.node.isRequired,
  };

  render() {
    return this.props.children;
  }
}



// WEBPACK FOOTER //
// ./src/components/FilterMenu/SearchMenu.js